import { connect } from 'react-redux';
import appSelector from 'selectors/app';
import Layout from '../components/Layout';

const App = connect(appSelector)(Layout);

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.ts